<template>
  <transition
    :name="transition"
    mode="in-out"
    appear
    :appear-active-class="enterClass"
    :enter-active-class="enterClass"
    :leave-active-class="leaveClass"
    @beforeEnter="beforeEnter"
    @afterLeave="afterLeave"
  >
    <div
      :class="classes"
      v-if="show"
    >
      <div
        class="modal-background"
        @click="disable ? null : deactive()"
      ></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">{{ title }}</p>
          <button
            class="delete"
            @click="disable ? null : deactive()"
          ></button>
        </header>
        <section class="modal-card-body">
          <slot></slot>
        </section>
        <footer
          v-if="hasFooter"
          class="modal-card-foot"
        >
          <slot name="footer"></slot>
        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
import BaseModal from "utils/modal";

import { eBus } from "utils/eventbus";

export default {
  mixins: [BaseModal],

  props: {
    title: {
      type: String
    },
    okText: {
      type: String,
      default: "Ok"
    },
    cancelText: {
      type: String,
      default: "Cancel"
    },
    hasFooter: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      disable: false
    };
  },

  computed: {
    classes () {
      return ["modal", "animated", "is-active"];
    }
  },

  methods: {
    ok () {
      this.$emit("ok");
    },

    cancel () {
      this.$emit("cancel");
    }
  },
   beforeDestroy () {
      document.body.removeChild(this.$el)
    },
  created () {
    let me = this;
    eBus.$on("close-modal", data => {
      me.show = false;
    });
    eBus.$on("disable-closing", data => {
      this.disable = true;
    });
    eBus.$on("enable-closing", data => {
      this.disable = false;
    });
  }
};
</script>
